import React from 'react';
import { Link } from 'react-router-dom';
import './StartPage.css';

export default function StartPage() {
  return (
    <div className="startpage-container">
      <div className="startpage-content">
        <h1 className="startpage-title">Welcome to Text Analyzer</h1>
        <p className="startpage-description">
          A powerful, fast, and simple tool to analyze your text in real-time. Whether you want to convert case, extract emails, count words, or preview formatting — it's all here.
        </p>
        <Link to="/Textform" className="startpage-button">Start Analyzing</Link>
      </div>
    </div>
  );
}
